export default __webpack_public_path__ + "static/media/man2.b49b21a7.png";